
import React from 'react';

const StatsSection: React.FC = () => {
  const stats = [
    {
      number: "30+",
      label: "Projects Completed",
      description: "Successfully inspected coating projects"
    },
    {
      number: "NATIONWIDE",
      label: "Coverage",
      description: "Coast-to-coast service capability"
    },
    {
      number: "25+ YEARS",
      label: "Experience",
      description: "Protecting critical infrastructure"
    }
  ];

  return (
    <section className="py-20 bg-blue-600">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 text-center text-white">
          {stats.map((stat, index) => (
            <div key={index} className="space-y-4">
              <div className="text-5xl md:text-6xl font-bold">
                {stat.number}
              </div>
              <div className="text-xl font-semibold">
                {stat.label}
              </div>
              <div className="text-blue-100">
                {stat.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
